import { FC } from 'react';
import type { QualidadePayload, TipoLote } from '@/types/dashboards';
import { TODAS_MAQUINAS } from '@/utils/equiplexQualidade';

interface Props {
  payload: QualidadePayload;
  tipo: TipoLote;
  onTipo: (tipo: TipoLote) => void;
  maquina: string;
  onMaquina: (maquina: string) => void;
}

/** Fila (produto acabado × frascos) e máquina: os dois recortes que valem para a aba inteira. */
const FiltrosQualidade: FC<Props> = ({ payload, tipo, onTipo, maquina, onMaquina }) => (
  <div className="flex flex-wrap items-center gap-3">
    <div role="group" aria-label="Fila do CQ" className="inline-flex rounded-lg border border-theme-border p-0.5 text-xs">
      {payload.tipos.map((t) => (
        <button
          key={t.tipo}
          type="button"
          aria-pressed={tipo === t.tipo}
          onClick={() => onTipo(t.tipo)}
          className={`rounded-md px-3 py-1.5 ${
            tipo === t.tipo ? 'bg-surface-hover font-medium text-content-primary' : 'text-content-muted hover:text-content-primary'
          }`}
        >
          {t.rotulo}
        </button>
      ))}
    </div>
    <label className="flex items-center gap-2 text-xs text-content-muted">
      Máquina
      <select
        aria-label="Máquina"
        value={maquina}
        onChange={(e) => onMaquina(e.target.value)}
        className="rounded-lg border border-theme-border bg-surface-primary px-3 py-1.5 text-sm text-content-primary"
      >
        <option value={TODAS_MAQUINAS}>Todas</option>
        {payload.por_tipo[tipo].maquinas.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
    </label>
  </div>
);

export default FiltrosQualidade;
